import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { NotificationSubscriber } from '../types/Notification'

export const fetchNotificationSubscribers = createAsyncThunk<
	Record<string, NotificationSubscriber[]>,
	string,
	ThunkConfig<string>
>('fetchNotificationSubscriber', async (notificationId, thunkApi) => {
	const {
		extra: { api },
		rejectWithValue
	} = thunkApi

	try {
		const res = await api.get<NotificationSubscriber[]>(
			`/globalSettings/notifications/${notificationId}/subscribers`
		)

		return { [notificationId]: res.data ?? [] }
	} catch (e) {
		console.log(e)
		appHandleError(e, 'fetchNotificationSubscriber', 'Failed to fetch notification subscribers')
		return rejectWithValue('Error occurred on fetching notification subscribers')
	}
})
